<template>
  <div class="loading">
    <div class="mask" v-if="isShowMask"></div>
    <div class="wrap">
      <div class="spinner-1" v-if="loadType === 1">
        <div class="rect1"></div>
        <div class="rect2"></div>
        <div class="rect3"></div>
        <div class="rect4"></div>
        <div class="rect5"></div>
      </div>
      <div class="spinner-2" v-else-if="loadType === 2"></div>
      <div class="spinner-3" :data-content="$t('slogen.title')" v-else-if="loadType === 3">{{$t('slogen.title')}}</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Loader',
  props: {
    loadType: {
      type: Number,
      default: 1,
      require: false
    },
    isShowMask: {
      type: Boolean,
      default: true,
      require: false
    }
  }
}
</script>
<style scoped>
  .loading{
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    height: 100%;
    width: 100%;
  }
  .loading.line{
    position: static;
  }
  .loading.line .mask{
    display: none;
  }
  .loading.line .wrap{
    margin: 30px 0;
    top: 0;
  }
  .mask{
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background-color: rgba(55,55,55,.6);
    height: 100%;
    z-index: 2000;
  }
  .fullscreen .mask{
    position: fixed;
  }
  .loading.black .mask{
    background-color: rgba(55,55,55,0);
    /*display: none;*/
  }
  .wrap{
    position: absolute;
    top: 20px;
    left: 50%;
    transform: translateX(-50%);
    z-index: 2001;
    -webkit-overflow-scrolling: touch;
    outline: 0;
  }
  .spinner-1 {
    margin: 0 auto;
    width: 50px;
    height: 35px;
    text-align: center;
    font-size: 10px;
  }
  .spinner-1 > div {
    background-color: #fff;
    opacity: 0.6;
    height: 100%;
    width: 3px;
    display: inline-block;
    -webkit-animation: stretchdelay 1.2s infinite ease-in-out;
    animation: stretchdelay 1.2s infinite ease-in-out;
  }
  .loading.black .spinner-1 > div{
    background-color: #333;
  }
  .spinner-1 .rect2 {
    -webkit-animation-delay: -1.1s;
    animation-delay: -1.1s;
  }
  .spinner-1 .rect3 {
    -webkit-animation-delay: -1.0s;
    animation-delay: -1.0s;
  }
  .spinner-1 .rect4 {
    -webkit-animation-delay: -0.9s;
    animation-delay: -0.9s;
  }
  .spinner-1 .rect5 {
    -webkit-animation-delay: -0.8s;
    animation-delay: -0.8s;
  }
  @-webkit-keyframes stretchdelay {
    0%, 40%, 100% { -webkit-transform: scaleY(0.4) }
    20% { -webkit-transform: scaleY(1.0) }
  }
  @keyframes stretchdelay {
    0%, 40%, 100% {
      transform: scaleY(0.4);
      -webkit-transform: scaleY(0.4);
    }
    20% {
      transform: scaleY(1.0);
      -webkit-transform: scaleY(1.0);
    }
  }
  /*spinner-2*/
  .spinner-2 {
    width: 60px;
    height: 60px;
    background-color: #fff;
    opacity: 0.6;
    margin: 0 auto;
    -webkit-animation: rotateplane 1.5s infinite ease-in-out;
    animation: rotateplane 1.5s infinite ease-in-out;
  }
  .loading.black .spinner-2{
    background-color: #333;
  }
  @-webkit-keyframes rotateplane {
    0% { -webkit-transform: perspective(120px) }
    50% { -webkit-transform: perspective(120px) rotateY(180deg) }
    100% { -webkit-transform: perspective(120px) rotateY(180deg)  rotateX(180deg) }
  }
  @keyframes rotateplane {
    0% {
      transform: perspective(120px) rotateX(0deg) rotateY(0deg);
      -webkit-transform: perspective(120px) rotateX(0deg) rotateY(0deg)
    }
    50% {
        transform: perspective(120px) rotateX(-180.1deg) rotateY(0deg);
        -webkit-transform: perspective(120px) rotateX(-180.1deg) rotateY(0deg)
    }
    100% {
          transform: perspective(120px) rotateX(-180deg) rotateY(-179.9deg);
          -webkit-transform: perspective(120px) rotateX(-180deg) rotateY(-179.9deg);
    }
  }
  /*spinner-3*/
  .spinner-3 {
    position: absolute;
    left: 50%;
    margin-left: -1.9em;
    color: hsla(0,0%,100%,.3);
    font: 600 300% Baskerville, 'Palatino Linotype', Palatino, serif;
    /*font-size: 300%;*/
    /*font-weight: 600;*/
    white-space: nowrap;
  }
  @keyframes loading {
    from { max-width: 0; }
  }
  .spinner-3:before {
    content: attr(data-content);
    position: absolute;
    overflow: hidden;
    /*max-width: 4em;*/
    max-width: 8em;
    color: white;
    animation: loading 6s infinite linear;
  }
  .loading.black .spinner-3{
    color: #ccc;
  }
  .loading.black .spinner-3:before{
    color: #666;
  }
</style>



// WEBPACK FOOTER //
// src/components/layout/Loader.vue